import { LocaleType } from "@/hooks/locale/useChangeLocale/types";

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const openExternalLink = (link: string) => {
  window.open(link, "_blank", "noopener,noreferrer");
};

export const downloadHandler = (url: string) => {
  if (!url) {
    throw new Error("Resource URL not provided! You need to provide one");
  }
  fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then(response => response.blob())
    .then(blob => {
      const element = document.createElement("a");
      const file = new Blob([blob]);
      element.href = URL.createObjectURL(file);
      element.download = url;
      element.click();
    })
    .catch(() => console.log("Failed to download"));
};

export const isLanguageCode = (value: string): value is LocaleType => {
  const validCodes: LocaleType[] = ["en", "es", "ru"];
  return validCodes.includes(value as LocaleType);
};

export const hashHandleScroll = (tags: string[], currentHash: string) => {
  const sections = tags
    .map(tag => {
      const element = document.querySelector(tag);
      if (!element) return null;
      const rect = element.getBoundingClientRect();
      return { url: tag, top: rect.top };
    })
    .filter(Boolean);

  const offset = 100;
  const activeSection = sections.reduce(
    (prev, curr) => {
      if (curr!.top - offset <= 0 && (prev === null || curr!.top > prev.top)) {
        return curr;
      }
      return prev;
    },
    null as { url: string; top: number } | null,
  );

  if (activeSection && activeSection.url !== currentHash) {
    return activeSection.url;
  }
};
